/* Gummy Gardens — flavour-reactive accents (2026-09-23).
   Sets html[data-gg-flavor] from the selected flavour on the product page only (founder 2026-09-23),
   tags each cart line with its flavour, and adds the trust/offer strip to the cart drawer and cart page.
   Reads the page only; never writes inside the Recharge widget. Offer copy mirrors the live offer table. */
(function () {
  var FLAVORS = {
    'tropical': 'Tropical', 'mixed-berry': 'Mixed Berry', 'mandarin-orange': 'Mandarin Orange',
    'cherry-apple': 'Cherry Apple', 'pineapple': 'Pineapple'
  };
  var root = document.documentElement;
  var KEY = 'gg-flavor';

  function slugFromText(text) {
    if (!text) return null;
    var t = text.toLowerCase();
    if (t.indexOf('sugar free') > -1 || t.indexOf('tropical') > -1) return 'tropical';
    if (t.indexOf('mixed berry') > -1) return 'mixed-berry';
    if (t.indexOf('mandarin') > -1) return 'mandarin-orange';
    if (t.indexOf('cherry apple') > -1) return 'cherry-apple';
    if (t.indexOf('pineapple') > -1) return 'pineapple';
    return null;
  }

  function setFlavor(slug, remember) {
    if (!slug || !FLAVORS[slug]) return;
    if (root.getAttribute('data-gg-flavor') !== slug) root.setAttribute('data-gg-flavor', slug);
    if (remember) { try { localStorage.setItem(KEY, slug); } catch (e) {} }
  }

  /* Product page: the checked "Flavors" option, or Tropical on the Sugar Free product */
  function productFlavor() {
    if (location.pathname.indexOf('/products/') === -1) return null;
    if (location.pathname.indexOf('sugar-free') > -1) return 'tropical';
    var fieldsets = document.querySelectorAll('variant-selects fieldset, variant-radios fieldset, .product-form__input');
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var legend = fs.querySelector('legend, .form__label, label');
      if (!legend || !/flavou?r/i.test(legend.textContent)) continue;
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) return slugFromText(checked.value);
      var sel = fs.querySelector('select');
      if (sel) return slugFromText(sel.value);
    }
    var anySelect = document.querySelector('variant-selects select[name*="Flavor"], select[name*="Flavor"]');
    return anySelect ? slugFromText(anySelect.value) : null;
  }

  /* Cart lines (drawer and /cart) */
  function tagCartLines() {
    var first = null;
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var name = row.querySelector('.cart-item__name');
      var opts = row.querySelector('.cart-item__details');
      var slug = slugFromText((opts ? opts.textContent : '') + ' ' + (name ? name.textContent : ''));
      if (!slug) return;
      if (!first) first = slug;
      row.setAttribute('data-gg-flavor', slug);
      if (name && !row.querySelector('.gg-flavor-chip')) {
        var chip = document.createElement('span');
        chip.className = 'gg-flavor-chip';
        chip.textContent = FLAVORS[slug];
        name.insertAdjacentElement('afterend', chip);
      }
    });
    return first;
  }

  var TRUST_HTML =
    '<p class="gg-trust__offer">Subscribe and save up to $24 (20%), with free US shipping on every subscription.</p>' +
    '<ul><li>30-day money-back guarantee</li><li>5g creatine per serving</li>' +
    '<li>Vegan and allergen-free</li><li>Made in the USA</li></ul>';

  function addTrustStrips() {
    var targets = document.querySelectorAll('.cart-drawer__footer, .cart__footer .cart__blocks, #main-cart-footer .cart__blocks');
    targets.forEach(function (el) {
      if (el.querySelector('.gg-trust')) return;
      var box = document.createElement('div');
      box.className = 'gg-trust';
      box.innerHTML = TRUST_HTML;
      el.insertBefore(box, el.firstChild);
    });
  }

  /* Free-shipping progress (A-03, 2026-09-23). Live rule from Shopify delivery profiles (founder 2026-09-30): US Economy
     ships free on every order (threshold $0; Standard 3–4 day is $9.90), subscriptions included. Reads /cart.js; paints one line at the top
     of the trust strip and only rewrites it when the text changes, so the drawer's MutationObserver never loops. */
  var FREE_SHIP_CENTS = 0; /* founder 2026-09-30: every US order ships free */
  var ship = { text: '', pending: false, last: 0, retry: null, cart: null };

  function shippingLine(cart) {
    if (!cart || !cart.item_count) return '';
    var hasSub = (cart.items || []).some(function (it) { return !!it.selling_plan_allocation; });
    var total = typeof cart.total_price === 'number' ? cart.total_price : cart.items_subtotal_price;
    if (hasSub || total >= FREE_SHIP_CENTS) return "Free US shipping on every order";
    var away = (FREE_SHIP_CENTS - total) / 100;
    return "You're $" + (away % 1 ? away.toFixed(2) : away) + " away from free US shipping";
  }

  function paintShipping() {
    document.querySelectorAll('.gg-trust').forEach(function (box) {
      var el = box.querySelector('.gg-trust__shipping');
      if (!el) { el = document.createElement('p'); el.className = 'gg-trust__shipping'; box.insertBefore(el, box.firstChild); }
      if (el.textContent !== ship.text) el.textContent = ship.text;
      var hide = !ship.text;
      if (el.hidden !== hide) el.hidden = hide;
    });
  }

  function updateShipping() {
    if (!document.querySelector('.gg-trust') || typeof fetch !== 'function') return;
    var now = Date.now();
    if (ship.pending || now - ship.last < 800) {
      paintShipping();
      if (!ship.retry) ship.retry = setTimeout(function () { ship.retry = null; updateShipping(); }, 900);
      return;
    }
    ship.pending = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { ship.text = shippingLine(cart); ship.cart = cart; })
      .catch(function () {})
      .then(function () { ship.pending = false; ship.last = Date.now(); try { paintShipping(); } catch (e) {} try { paintRecs(); } catch (e) {} });
  }


  /* Cart recommendations (founder 2026-09-30): always different from what is in the cart — Sugar Free Tropical
     when it is not in the cart, plus the next Low Sugar flavour that is not in the cart. Replaces the Upsell.com
     product-level widget, which could only suggest the same product (flavours are variants of one product). */
  var RECS = {
    order: ['tropical', 'mixed-berry', 'mandarin-orange', 'pineapple', 'cherry-apple'],
    handles: { tropical: 'gummy-gardens-sugar-free-creatine-gummies', other: 'low-sugar-creatine-gummies' },
    data: null, loading: false, key: ''
  };
  function recsLoad() {
    if (RECS.data || RECS.loading || typeof fetch !== 'function') return;
    RECS.loading = true;
    Promise.all([RECS.handles.tropical, RECS.handles.other].map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.json(); });
    })).then(function (ps) {
      var d = {};
      ps.forEach(function (p) {
        (p.variants || []).forEach(function (v) {
          if (!/1PK/i.test(v.title) || !v.available) return;
          var slug = p.handle.indexOf('sugar-free') > -1 ? 'tropical' : slugFromText(v.title);
          if (!slug || d[slug]) return;
          var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
          d[slug] = { id: v.id, price: v.price, img: img, line: slug === 'tropical' ? 'Sugar Free · 1 bag' : 'Low Sugar · 1 bag', url: '/products/' + p.handle + '?variant=' + v.id };
        });
      });
      RECS.data = d;
    }).catch(function () {}).then(function () { RECS.loading = false; RECS.key = ''; try { paintRecs(); } catch (e) {} });
  }
  function recsPick(cart) {
    var inCart = {};
    (cart && cart.items || []).forEach(function (it) {
      var slug = /sugar-free/.test(it.handle || '') ? 'tropical' : slugFromText((it.variant_title || '') + ' ' + (it.product_title || ''));
      if (slug) inCart[slug] = true;
    });
    return RECS.order.filter(function (s) { return !inCart[s] && RECS.data && RECS.data[s]; }).slice(0, 2);
  }
  function money(c) { var d = c / 100; return '$' + (d % 1 ? d.toFixed(2) : d); }
  function paintRecs() {
    var cart = ship.cart;
    var targets = document.querySelectorAll('#CartDrawer .drawer__footer, .cart__footer');
    if (!targets.length) return;
    if (!RECS.data) { recsLoad(); return; }
    var picks = (cart && cart.item_count) ? recsPick(cart) : [];
    var key = picks.join(',');
    targets.forEach(function (host) {
      var box = host.querySelector(':scope > .gg-recs');
      if (!picks.length) { if (box) box.remove(); return; }
      if (box && box.getAttribute('data-key') === key) return;
      if (!box) { box = document.createElement('div'); box.className = 'gg-recs'; host.insertBefore(box, host.firstChild); }
      box.setAttribute('data-key', key);
      box.innerHTML = '<p class="gg-recs__title">Try another flavor</p>' + picks.map(function (s) {
        var r = RECS.data[s];
        return '<div class="gg-recs__item" data-gg-flavor="' + s + '"><a href="' + r.url + '"><img src="' + r.img + '&width=120" alt="" width="56" height="56"></a>' +
          '<div class="gg-recs__info"><a href="' + r.url + '" class="gg-recs__name">' + FLAVORS[s] + '</a><span class="gg-recs__line">' + r.line + ' · ' + money(r.price) + '</span></div>' +
          '<button type="button" class="gg-recs__add" data-variant="' + r.id + '">Add</button></div>';
      }).join('');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.gg-recs__add');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true; btn.textContent = 'Adding…';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(btn.getAttribute('data-variant')), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (x) { return x.id; }); body.sections_url = location.pathname; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (drawer && drawer.renderContents && res.sections && !document.querySelector('.cart__footer')) { drawer.renderContents(res); }
        else { location.reload(); }
      })
      .catch(function () { location.reload(); });
  });

  function refresh() {
    var pf = productFlavor();
    var cf = tagCartLines();
    addTrustStrips();
    try { updateShipping(); } catch (e) {}
    /* Founder 2026-09-23: flavour colour on the product (purchase) page only; everywhere else stays brand. */
    if (pf) setFlavor(pf, true);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; refresh(); }, 30);
  }

  /* Variant changes: capture phase (Dawn may stop bubbling), clicks on pills, and Dawn's pub/sub event */
  ['change', 'click'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) {
        schedule(); setTimeout(schedule, 400);
      }
    }, true);
  });
  document.addEventListener('DOMContentLoaded', function () {
    refresh();
    if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, schedule);
    ['cart-drawer', 'cart-items', '#main-cart-footer', '#CartDrawer', 'product-info'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) new MutationObserver(schedule).observe(el, { childList: true, subtree: true });
    });
  });
  if (document.readyState !== 'loading') refresh();
})();
